import { memo, SVGProps } from 'react';

const VectorIcon6 = (props: SVGProps<SVGSVGElement>) => (
  <svg preserveAspectRatio='none' viewBox='0 0 4 4' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M2.156 3.095C2.83918 3.095 3.393 2.54118 3.393 1.858C3.393 1.17482 2.83918 0.621 2.156 0.621C1.47282 0.621 0.919 1.17482 0.919 1.858C0.919 2.54118 1.47282 3.095 2.156 3.095Z'
      fill='white'
    />
  </svg>
);
const Memo = memo(VectorIcon6);
export { Memo as VectorIcon6 };
